module.exports = __webpack_public_path__ + "static/media/track-krantenwijk.cca4a708.png";